import React, { useState } from 'react';
import { Footer } from './SiteTransfer.stc';
import Button from '../../Button';
import Modal from '../../Modal';
import Input from '../../Input';
import Label from '../../Label';
import Alert from '../../Alert';

function SiteTransfer({ onClose, site }) {
    const [email, setEmail] = useState();

    return (
        <Modal
            size="sm"
            onClose={onClose}
            header={
                <div>
                    <strong>SITE TRANSFER</strong> ({site.id})
                </div>
            }
            footer={
                <Footer>
                    <Button onClick={onClose} type="link">
                        Cancel
                    </Button>
                    <Button>Transfer Site</Button>
                </Footer>
            }
        >
            <Alert type="warning">
                <strong>Warning</strong> Site config chagnes will affect your
                website URL accessibility
            </Alert>

            <form style={{ marginTop: 25 }}>
                <Label htmlFor="recepientEmail">Transfer Site To:</Label>
                <Input
                    id="recepientEmail"
                    value={email}
                    onChange={setEmail}
                    placeholder="Recepient Email Address"
                />
            </form>

            <p>
                Enter recipient’s email address. Recipient need to have an
                account in Dorik.co to receive the website.
            </p>
        </Modal>
    );
}

export default SiteTransfer;
